export const PageSizes: number[] = [5, 10, 15, 25];
export const DEBOUNCE_TIME: number = 200;
export const DEBOUNCE_TIME2: number = 500;
export const RESULT_SUGGESTIONS: number = 4;
export const MINIMUM_LETTERS_SEARCH_START = 1;
export const TOP_VIDEOS_COLORS: string[] = ["#22CCEE", "#444CE7", "#EEAAFD", "#9F1AB1", "#E62E05", "#FDB022", "#A15C07", "#000000", "#027A48", "#85E13A"];